var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-circle-right") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Evo-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-columns",
    transform: "translate(-953.000000, -565.000000)",
    fill: "#0088A9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-circle-right",
    transform: "translate(953.000000, 565.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.37258302,0 0,5.37258302 0,12 C0,18.6274171 5.37258302,24 12,24 C18.6274171,24 24,18.6274171 24,12 C23.9928353,5.37555307 18.624447,0.00716484764 12,0 Z M16.9610001,13.3580001 L9.61500004,18.9920001 C9.26084756,19.2674413 8.78624162,19.3319558 8.37141514,19.161044 C7.95658866,18.9901322 7.66517583,18.6100118 7.60784148,18.1650347 C7.55050713,17.7200576 7.73604632,17.278483 8.09400003,17.0080001 L14.3650001,12.1980001 C14.4283299,12.1510323 14.4656727,12.0768457 14.4656727,11.998 C14.4656727,11.9191544 14.4283299,11.8449678 14.3650001,11.798 L8.09400003,6.99200003 C7.73604632,6.72151713 7.55050713,6.27994252 7.60784148,5.83496541 C7.66517583,5.3899883 7.95658866,5.00986794 8.37141514,4.83895612 C8.78624162,4.66804429 9.26084756,4.73255877 9.61500004,5.00800002 L16.9610001,10.642 C17.3834507,10.965789 17.6311557,11.4677371 17.6311557,12.0000001 C17.6311557,12.532263 17.3834507,13.0342111 16.9610001,13.3580001 L16.9610001,13.3580001 Z",
    id: "icon/arrow-circle-right"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/arrow-circle-right.6841775a1e08c916f18ffcb5eff2ac01.svg";
export { ForwardRef as ReactComponent };